// hooks/useR0006Header.js - Enhanced version building on your existing structure
import { useState } from 'react';
import React from 'react';
import DateRangeSelectionModal from 'components/ReportHeader/modals/DateRangeSelectionModal';
import { createR0006HeaderControls } from '../utils/headerControlUtils';

/**
 * Enhanced custom hook that manages R0006 header state and controls
 * Now supports area/store navigation and breadcrumbs
 */
export default function useR0006Header({
  dateRange,
  selectedArea,
  dataReady,
  pageLoading,
  onDateRangeSubmit,
  onAreaChange,
  onExport,
  reportData,
  // New props for area/store support
  currentView,
  isAreasView,
  areasData,
  selectedAreaData,
  areaName,
  hasFullAccess,
  filteredAreas
}) {
  const [modalOpen, setModalOpen] = useState(false);

  const handleCalendarClick = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);
  
  const handleDateRangeSubmit = (newDateRange) => {
    setModalOpen(false);
    onDateRangeSubmit(newDateRange);
  };

  // Enhanced header controls using the utility function with new parameters
  const { leftControls, centerControls, rightControls } = createR0006HeaderControls({
    dateRange,
    selectedArea,
    dataReady,
    pageLoading,
    onDateRangeSubmit,
    onAreaChange,
    onExport,
    onCalendarClick: handleCalendarClick,
    reportData,
    // New parameters for area/store support
    currentView,
    isAreasView,
    areasData,
    selectedAreaData,
    areaName,
    hasFullAccess,
    filteredAreas
  });

  // Enhanced modals with better context
  const modals = (
    <DateRangeSelectionModal
      key="date-range-modal"
      open={modalOpen}
      onClose={handleModalClose}
      onSubmit={handleDateRangeSubmit}
      currentDateRange={dateRange}
      loading={false}
      title={`Select Report Date Range${isAreasView ? '' : ` - ${areaName}`}`}
      description={
        isAreasView 
          ? "Choose a single date or date range to load efficiency and productivity data for all areas."
          : `Choose a single date or date range to load efficiency and productivity data for ${areaName} stores.`
      }
      theme={{
        primary: '#2c3e50',
        accent: '#f1c40f',
        text: '#2c3e50'
      }}
    />
  );

  return {
    leftControls,
    centerControls,
    rightControls,
    modals,
    // Additional returns for enhanced functionality
    modalOpen,
    setModalOpen,
    currentView,
    isAreasView
  };
}